import classesCsa from "./S21CsaStyles.module.css";
import React, { KeyboardEvent, useState } from "react";
import { Tooltip } from "react-tooltip";
import { useCallback, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isFirefox } from "react-device-detect";
import axios, { AxiosError } from "axios";
import { S21CsaInterface } from "../../interface/redux-state/S21CsaInterface";
import { ezfToUpperOnBlur, ezfToUpperOnKeyDown } from "./creditCardForm";
import {
  extractClientLibrary,
  extractRequestParameters,
  getCardType,
  extractDomain,
  loadCybersourceJS,
  parseToken,
} from "../../utils/utils";
import {
  cardTypeAction,
  changeAction,
  errorAction,
  loadingAction,
  toggleCreditCardProfileAction,
  setCaptureContext,
  setMicroformToken,
  setDisableField,
} from "../../redux-store/reducer/s21CsaSlice";
import { contextLoadedAction, microformInitializedAction, tokenCreatedAction } from "../../redux-store/reducer/paymentSlice";
import PaymentService from "../../service/paymentService";
import { tceppsActions } from "../../redux-store/reducer/tcepps_slice";
import _ from "lodash";
// import { profileAdd, newOrder } from "../../utils/cpgmuiUtil";
import { isCybersourceTimedout, getTimedoutDummyToken, keyUpDateEvent, getCurrentYearMonth } from "../../utils/calendarUtil";
import { TceppsTestData, isTestingApp } from "../../utils/TestLoadData";
import { isValidState, isValidUSZip } from "../../utils/UsStates";
import { LogService, LOGERRORLEVEL } from "../../service/logService";
import { setAppName } from "../../utils/consoleLog";
import { getStringify } from "../../utils/utils";
import beepSound from "../../resources/beep.wav";
import { componentVarObject, ComponentVarProps } from "../../utils/ComponentConstant";
import CpgmuiService from "../../service/CpgmuiService";
import classNames from "classnames";

type Microform = {
  microform: (cardType: any, options: any) => any;
};
const flexStyles = {
  input: {
    cursor: "text",
    color: "#171719",
    "font-size": "8pt",
    "font-family": '"Arial", sans-serif',
  },
  "::placeholder": { color: "blue" },
  ":focus": { color: "blue" },
  ":disabled": { cursor: "not-allowed" },
  valid: { color: "#171719" },
  invalid: { color: "#a94442" },
} as React.CSSProperties;

const PROCESS_TRANSACTION = "processTransaction";
const TOGGLE_ADD_PROFILE = "toggleAddProfile";
const PROFILE_ADD = "profileAdd";
const NEW_ORDER_REVERSAL = "newOrder_reversal";

const toDay = new Date();
let creditCardMicroNumber: any;

const errorFlags = {
  ccExpMissing: false,
  ccExpMonthInvalid: false,
  ccExpExpired: false,
  customerNameMissing: false,
  customerAddress1Missing: false,
  cardBrandMissing: false,
  customerAddress2Missing: false, // always false.
  customerCityMissing: false,
  customerStateMissing: false,
  customerZIPMissing: false,
  customerCountryCodeMissing: false,
};
const INVALIDAXIOSMESSAGE = "AxiosError. ";

export function S21CsaComponent(this: any) {
  const dispatch = useDispatch();
  const temp = useSelector((state: any) => state.s21csa) as unknown;
  const s21CsaState = temp as S21CsaInterface;
  const tceppsState = useSelector((state: any) => state.tcepps);
  const paymentInfo = useSelector((state: any) => state.paymentInfo);
  const [errorState, setErrorState] = useState(errorFlags);
  const [loadedTestData, setLoadedTestData] = useState(false);
  const [proxyUrl, setProxyUrl] = useState("");
  const [creditCardNumber, setCreditCardNumber] = useState(false);
  const [validatedOnce, setValidatedOnce] = useState(false);
  const [validationMessages, setValidationMessages] = useState("");
  const componentObjRef = useRef<ComponentVarProps>(componentVarObject);
  const creditCardMissingRef = useRef(true);
  const creditCardInvalidRef = useRef(false);
  const customerNameRef = useRef<HTMLInputElement>(null);
  const customerAddress1Ref = useRef<HTMLInputElement>(null);
  const ccExpRef = useRef<HTMLInputElement>(null);
  const customerCityRef = useRef<HTMLInputElement>(null);
  const customerStateRef = useRef<HTMLInputElement>(null);
  const customerCountryCodeRef = useRef<HTMLInputElement>(null);
  const profileOverrideFlagRef = useRef<HTMLInputElement>(null);
  const postCodeRef = useRef<HTMLInputElement>(null);

  const { appKey } = useParams();

  const validateForm = useCallback(() => {
    let temp = errorState;
    let hasError = false;
    setValidatedOnce(true);
    if (creditCardMissingRef.current) {
      // temp = { ...temp, creditCardMissing: true, creditCardInvalid: false };
      hasError = true;
      if (creditCardMicroNumber !== undefined && creditCardMicroNumber !== null) {
        creditCardMicroNumber.focus();
      }
    } else if (creditCardInvalidRef.current) {
      // temp = { ...temp, creditCardMissing: false, creditCardInvalid: true };
      hasError = true;
      if (creditCardMicroNumber !== undefined && creditCardMicroNumber !== null) {
        creditCardMicroNumber.focus();
      }
    }
    if (!s21CsaState.customerName) {
      temp = { ...temp, customerNameMissing: true };
      if (!hasError) {
        customerNameRef.current?.focus();
      }
      hasError = true;
    }
    if (!s21CsaState.customerAddress1) {
      temp = { ...temp, customerAddress1Missing: true };
      if (!hasError) {
        customerAddress1Ref.current?.focus();
      }
      hasError = true;
    }
    if (!s21CsaState.customerCity) {
      temp = { ...temp, customerCityMissing: true };
      if (!hasError) {
        customerCityRef.current?.focus();
      }
      hasError = true;
    }
    if (!s21CsaState.customerState || !isValidState(s21CsaState.customerState)) {
      temp = { ...temp, customerStateMissing: true };
      if (!hasError) {
        customerStateRef.current?.focus();
      }
      hasError = true;
    }
    if (!s21CsaState.customerZIP || !isValidUSZip(s21CsaState.customerZIP)) {
      temp = { ...temp, customerZIPMissing: true };
      if (!hasError) {
        postCodeRef.current?.focus();
      }
      hasError = true;
    }
    if (!s21CsaState.customerCountryCode) {
      temp = { ...temp, customerCountryCodeMissing: true };
      if (!hasError) {
        customerCountryCodeRef.current?.focus();
      }
      hasError = true;
    }
    if (!s21CsaState.ccExp) {
      temp = { ...temp, ccExpMissing: true };
      if (!hasError) {
        ccExpRef.current?.focus();
      }
      hasError = true;
    } else {
      if (s21CsaState.ccExp.length === 7) {
        let cardYearMonth = s21CsaState.ccExp.substring(3, 8) + s21CsaState.ccExp.substring(0, 2);

        if (!s21CsaState.ccExp.match("^((0[1-9])|(1[0-2]))/([2-9][0-9][0-9][0-9])$")) {
          temp = { ...temp, ccExpMonthInvalid: true };
          if (!hasError) {
            ccExpRef.current?.focus();
          }
          hasError = true;
        } else if (cardYearMonth < getCurrentYearMonth()) {
          temp = { ...temp, ccExpExpired: true };
          if (!hasError) {
            ccExpRef.current?.focus();
          }
          hasError = true;
        }
      } else {
        temp = { ...temp, ccExpMissing: true };
        if (!hasError) {
          ccExpRef.current?.focus();
        }
        hasError = true;
      }
    }
    if (hasError) {
      setErrorState(temp);
    }
    return !hasError;
  }, [errorState, s21CsaState]);

  const captureTokenInformation = useCallback(
    (serviceOperation: string) => {
      const validateCardType = () => {
        let isGood = true;
        if (creditCardMissingRef.current) {
          isGood = false;
          dispatch(errorAction("Please enter a valid Credit Card Number."));
        } else if (creditCardInvalidRef.current) {
          isGood = false;
          dispatch(errorAction("Please enter a Visa or a Mastercard or amex or Discover card number."));
        } else {
          dispatch(errorAction(""));
        }
        return isGood;
      };
      // there are 2 date validations. We do it here before we get the token from the microform.
      // If the date is invalid we skip createToken. Date validations are also done to show
      // screen errors... should refactor this to do it once.
      const validateDate = (cardExpirationDate: string) => {
        let isGood = true;
        if (cardExpirationDate) {
          if (cardExpirationDate.length === 7) {
            let cardYearMonth = cardExpirationDate.substring(3, 8) + cardExpirationDate.substring(0, 2);
            if (!cardExpirationDate.match("^((0[1-9])|(1[0-2]))/([2-9][0-9][0-9][0-9])$")) {
              isGood = false;
              dispatch(errorAction("Expiration month is invalid"));
            } else if (cardYearMonth < getCurrentYearMonth()) {
              isGood = false;
              dispatch(errorAction("The credit card date is expired."));
            }
          } else {
            isGood = false;
            dispatch(errorAction("Please enter a valid credit card month and date"));
          }
        } else {
          isGood = false;
          dispatch(errorAction("Please enter a valid Card Expiration Date."));
        }
        return isGood;
      };
      const { ccExp } = s21CsaState;
      let isCardGood = validateCardType();
      let isDateValid = validateDate(ccExp);
      if (isCardGood && isDateValid) {
        dispatch(setDisableField());
        if (isCybersourceTimedout(toDay)) {
          dispatch(setMicroformToken(getTimedoutDummyToken()));
          const { token, jti, lastFourDigits } = getTimedoutDummyToken();
          dispatch(tokenCreatedAction({ token, jti, lastFourDigits }));
        } else {
          const options = {
            expirationMonth: ccExp.substring(0, 2),
            expirationYear: ccExp.substring(3, 8),
          };
          paymentInfo.microform.createToken(options, (err: Error, token: any) => {
            if (err) {
              LogService.logMessage("S21CSA", LOGERRORLEVEL, "captureTokenInformation validateDate call failed. " + getStringify(err));
              console.log("error = " + getStringify(err));
              setValidationMessages("Error in microform createToken. " + err.message + ". Please check console..");
              componentObjRef.current.isBackgroundRed = true;
              //dispatch(errorAction(getCreateTokenError(err)));
            } else {
              dispatch(setMicroformToken(token));
              // this will trigger the "submit" useEffect
              const { jti, lastFourDigits } = parseToken(token);
              dispatch(tokenCreatedAction({ token, jti, lastFourDigits }));
              dispatch(tceppsActions.serviceOperationAction({ ...s21CsaState, serviceOperation }));
            }
          });
        }
      }
    },
    [dispatch, paymentInfo.microform, s21CsaState],
  );

  const submitProfileAdd = () => {
    const tcepps = document.getElementsByName("tcepps")[0] as HTMLFormElement;
    const ppa = document.getElementsByName("ppa")[0] as HTMLFormElement;
    // tcepps.serviceOperation.value = "profileAdd";
    // profileAdd(tcepps, ppa);
    const s21csaObj = {
      "ppa.cardBrand": ppa.cardBrand.value,
      "ppa.ccAccountNum": ppa.ccAccountNum.value,
      "ppa.ccExp": ppa.ccExp.value,
      "ppa.avsName": ppa.avsName.value,
      "ppa.avsAddress1": ppa.avsAddress1.value,
      "ppa.avsAddress2": ppa.avsAddress2.value,
      "ppa.avsCity": ppa.avsCity.value,
      "ppa.avsState": ppa.avsState.value,
      "ppa.avsZip": ppa.avsZip.value,
      "ppa.avsCountryCode": ppa.avsCountryCode.value,
      "ppa.customerName": ppa.customerName.value,
      "ppa.customerAddress1": ppa.customerAddress1.value,
      "ppa.customerAddress2": ppa.customerAddress2.value,
      "ppa.customerCity": ppa.customerCity.value,
      "ppa.customerState": ppa.customerState.value,
      "ppa.customerZIP": ppa.customerZIP.value,
      "ppa.customerCountryCode": ppa.customerCountryCode.value,
      "ppa.orderDefaultAmount": ppa.orderDefaultAmount.value,
      "ppa.customerEmail": ppa.customerEmail.value,
      "ppa.merchantID": ppa.merchantID.value,
      "ppa.profileOverrideFlag": profileOverrideFlagRef.current?.checked ? "Y" : "N",
      "ppa.orbitalConnectionUsername": ppa.orbitalConnectionUsername.value,
      "ppa.orbitalConnectionPassword": ppa.orbitalConnectionPassword.value,
      "ppa.orderDefaultDescription": ppa.orderDefaultDescription.value,
      "ppa.captureContext": ppa.captureContext.value,
      "ppa.microformToken": ppa.microformToken.value,
      "tcepps.lastFourDigits": tcepps.lastFourDigits.value,
      "tcepps.serviceOperation": "profileAdd",
      "tcepps.app": tcepps.app.value,
      "tcepps.token": tcepps.token.value,
      "tcepps.sign": tcepps.sign.value,
      "tcepps.proxyUrl": proxyUrl,
      "tcepps.encryptedRequest": tcepps.encryptedRequest.value,
      "tcepps.encryptedRequestKey": tcepps.encryptedRequestKey.value,
    };
    // console.log(s21csaObj);
    CpgmuiService.submitServiceOperationRest(s21csaObj)
      .then((resp: any) => {
        setValidationMessages("");
        componentObjRef.current.isBackgroundRed = false;
        // console.log(resp.data);
        window.parent.postMessage({ type: "handleResponse", payload: resp.data }, "*");
      })
      .catch((err: Error | AxiosError) => {
        // console.log(err);
        if (axios.isAxiosError(err)) {
          // Access to config, request, and response
          setValidationMessages(INVALIDAXIOSMESSAGE + "call to submitCsaRest failed. " + err.message + ". Please check console..");
        } else {
          // Just a stock error
          setValidationMessages("Error in submitCsaRest. " + err.message + ". Please check console..");
        }
        // isBackgroundRed = true;
        componentObjRef.current.isBackgroundRed = true;
        LogService.logMessage(
          "S21CSA",
          LOGERRORLEVEL,
          "Call to submit form submitCsaRest failed:" + (err ? getStringify(err.message) : "null"),
        );
      });
  };

  const submitNewOrderReversal = () => {
    const tcepps = document.getElementsByName("tcepps")[0] as HTMLFormElement;
    const pno = document.getElementsByName("pno")[0] as HTMLFormElement;
    tcepps.serviceOperation.value = "newOrder_reversal";
    const s21csaNewOrderObj = {
      "pno.cardBrand": pno.cardBrand.value,
      "pno.ccAccountNum": pno.ccAccountNum.value,
      "pno.ccExp": pno.ccExp.value,
      "pno.avsName": pno.avsName.value,
      "pno.avsAddress1": pno.avsAddress1.value,
      "pno.avsAddress2": pno.avsAddress2.value,
      "pno.avsCity": pno.avsCity.value,
      "pno.avsState": pno.avsState.value,
      "pno.avsZip": pno.avsZip.value,
      "pno.avsCountryCode": pno.avsCountryCode.value,
      "pno.customerName": pno.customerName.value,
      "pno.customerAddress1": pno.customerAddress1.value,
      "pno.customerAddress2": pno.customerAddress2.value,
      "pno.customerCity": pno.customerCity.value,
      "pno.customerState": pno.customerState.value,
      "pno.customerZIP": pno.customerZIP.value,
      "pno.customerCountryCode": pno.customerCountryCode.value,
      "pno.addProfileFromOrder": pno.addProfileFromOrder.value,
      "pno.customerEmail": pno.customerEmail.value,
      "pno.merchantID": pno.merchantID.value,
      "pno.profileOrderOverideInd": pno.profileOrderOverideInd.value,
      "pno.orbitalConnectionUsername": pno.orbitalConnectionUsername.value,
      "pno.orbitalConnectionPassword": pno.orbitalConnectionPassword.value,
      "pno.switchSoloIssueNum": pno.switchSoloIssueNum.value,
      "pno.switchSoloCardStartDate": pno.switchSoloCardStartDate.value,
      "pno.authenticationECIInd": pno.authenticationECIInd.value,
      "pno.captureContext": pno.captureContext.value,
      "pno.microformToken": pno.microformToken.value,
      "tcepps.lastFourDigits": tcepps.lastFourDigits.value,
      "tcepps.serviceOperation": "newOrder_reversal",
      "tcepps.app": tcepps.app.value,
      "tcepps.token": tcepps.token.value,
      "tcepps.sign": tcepps.sign.value,
      "tcepps.proxyUrl": proxyUrl,
      "tcepps.encryptedRequest": tcepps.encryptedRequest.value,
      "tcepps.encryptedRequestKey": tcepps.encryptedRequestKey.value,
    };
    // newOrder(tcepps, pno);
    CpgmuiService.submitServiceOperationRest(s21csaNewOrderObj)
      .then((resp: any) => {
        setValidationMessages("");
        componentObjRef.current.isBackgroundRed = false;
        // console.log(resp.data);
        window.parent.postMessage({ type: "handleResponse", payload: resp.data }, "*");
      })
      .catch((err: Error | AxiosError) => {
        // console.log(err);
        if (axios.isAxiosError(err)) {
          // Access to config, request, and response
          setValidationMessages(INVALIDAXIOSMESSAGE + "call to submitCsaRest failed. " + err.message + ". Please check console..");
        } else {
          // Just a stock error
          setValidationMessages("Error in submitCsaRest. " + err.message + ". Please check console..");
        }
        // isBackgroundRed = true;
        componentObjRef.current.isBackgroundRed = true;
        LogService.logMessage(
          "S21CSA",
          LOGERRORLEVEL,
          "Call to submit form submitCsaRest failed:" + (err ? getStringify(err.message) : "null"),
        );
      });
  };

  //submit
  useEffect(() => {
    if (paymentInfo.token) {
      if (tceppsState.serviceOperation === PROFILE_ADD) {
        submitProfileAdd();
      } else if (tceppsState.serviceOperation === NEW_ORDER_REVERSAL) {
        submitNewOrderReversal();
      }
    }
  });

  // useEffect if screen/page input parameters change
  useEffect(() => {
    const decryptInputParameterAsync = async (app: string, encryptedRequestKey: string, encryptedRequest: string) => {
      let decryptParamsResponse: any;

      try {
        const response = await PaymentService.getDecryptRequest(app, encryptedRequestKey, encryptedRequest);
        decryptParamsResponse = response.data;
      } catch (err: any) {
        LogService.logMessage("S21CSA", LOGERRORLEVEL, "PaymentService.getDecryptRequest call failed. " + err.message);
        return false;
      }

      if (decryptParamsResponse && Object.keys(decryptParamsResponse).length > 0) {
        //don't save decrypted parameters
        // setDecryptParams(decryptParamsResponse);
        if (isTestingApp(decryptParamsResponse["app.TESTINGAPP"])) {
          let newState = {
            ...s21CsaState,
            customerName: TceppsTestData.ToBeAppTestData.S21CSA["tceppsRequest.ppa.customerName"].toLocaleUpperCase(),
            customerAddress1: TceppsTestData.ToBeAppTestData.S21CSA["tceppsRequest.ppa.customerAddress1"].toLocaleUpperCase(),
            customerAddress2: TceppsTestData.ToBeAppTestData.S21CSA["tceppsRequest.ppa.customerAddress2"].toLocaleUpperCase(),
            customerCity: TceppsTestData.ToBeAppTestData.S21CSA["tceppsRequest.ppa.customerCity"].toLocaleUpperCase(),
            customerState: TceppsTestData.ToBeAppTestData.S21CSA["tceppsRequest.ppa.customerState"].toLocaleUpperCase(),
            customerZIP: TceppsTestData.ToBeAppTestData.S21CSA["tceppsRequest.ppa.customerZIP"].toLocaleUpperCase(),
            customerCountryCode: TceppsTestData.ToBeAppTestData.S21CSA["tceppsRequest.ppa.customerCountryCode"].toLocaleUpperCase(),
            ccExp: TceppsTestData.ToBeAppTestData.S21CSA["tceppsRequest.ppa.expirationMonthYear"].toLocaleUpperCase(),
          };
          dispatch(changeAction(newState));
        }
        setProxyUrl(decryptParamsResponse["tcepps.proxyUrl"]);
        window.parent.postMessage({ type: "S21CSAINIT", payload: "loaded" }, "*");
      } else {
        LogService.logMessage("S21CSA", LOGERRORLEVEL, "Customer details not available. Please close and retry.");
      }
    };

    if (tceppsState.app !== undefined && tceppsState.app.length > 0 && !loadedTestData) {
      try {
        ((document.querySelector("#root") as HTMLDivElement).parentElement as HTMLDivElement).style.border = "0";
        ((document.querySelector("#root") as HTMLDivElement).parentElement as HTMLDivElement).style.margin = "0";
        ((document.querySelector("#root") as HTMLDivElement).parentElement as HTMLDivElement).style.padding = "0";
        ((document.querySelector("#root") as HTMLDivElement).parentElement as HTMLDivElement).style.position = "relative";
        ((document.querySelector("#root") as HTMLDivElement).parentElement as HTMLDivElement).style.overflow = "auto";
        (document.querySelector("#root") as HTMLDivElement).style.border = "0";
        (document.querySelector("#body") as HTMLDivElement).style.border = "0";
        (document.querySelector("#root") as HTMLDivElement).style.margin = "0";
        (document.querySelector("#body") as HTMLDivElement).style.margin = "0";
        (document.querySelector("#root") as HTMLDivElement).style.padding = "0";
        (document.querySelector("#body") as HTMLDivElement).style.padding = "0";
      } catch (exception) {}

      decryptInputParameterAsync(tceppsState.app, tceppsState.encryptedRequestKey, tceppsState.encryptedRequest);
      setLoadedTestData(true);
    }
  }, [tceppsState.app, tceppsState.encryptedRequestKey, tceppsState.encryptedRequest, dispatch, s21CsaState, loadedTestData]);

  // for handling events from client iframes.
  const windowMessageHandler = useCallback(
    (event: MessageEvent) => {
      if (event.data.type === PROCESS_TRANSACTION) {
        if (event.data.payload === TOGGLE_ADD_PROFILE) {
          dispatch(toggleCreditCardProfileAction());
        } else if (event.data.payload === PROFILE_ADD) {
          if (validateForm()) {
            captureTokenInformation(PROFILE_ADD);
          }
        } else if (event.data.payload === NEW_ORDER_REVERSAL) {
          if (validateForm()) {
            captureTokenInformation(NEW_ORDER_REVERSAL);
          }
        }
      } else if (
        creditCardMicroNumber &&
        event.data &&
        typeof event.data === "string" &&
        (event.data as string).indexOf("/*cybs-telgram*/") >= 0
      ) {
        const jsonObject = JSON.parse(event.data.replace("/*cybs-telgram*/", ""));
        if (
          jsonObject.data &&
          jsonObject.data.tabDirection &&
          jsonObject.data.tabDirection.focusShift &&
          jsonObject.event &&
          jsonObject.event === "event_blur" &&
          ((event.currentTarget &&
            (event.currentTarget as any).name &&
            ((event.currentTarget as any).name === "Mainframe" || (event.currentTarget as any).name === "creditCardFormIFrame")) ||
            (event.target &&
              (event.target as any).name &&
              ((event.target as any).name === "Mainframe" || (event.target as any).name === "creditCardFormIFrame")))
        ) {
          if (jsonObject.data.tabDirection.focusShift === "next") {
            profileOverrideFlagRef.current?.focus();
          } else if (jsonObject.data.tabDirection.focusShift === "previous") {
            customerCountryCodeRef.current?.focus();
          }
        }
      }
    },
    [dispatch, validateForm, captureTokenInformation],
  );

  // to setup and tear down window event handler for messages.
  // useEffect for windows message
  useEffect(() => {
    setAppName("S21CSA");
    window.addEventListener("message", windowMessageHandler, false);

    return () => {
      // console.log("REMOVING window message listener");
      window.removeEventListener("message", windowMessageHandler);
    };
  }, [windowMessageHandler]);

  // load request parameters
  useEffect(() => {
    const processRequest = async (req: any) => {
      const resp = await PaymentService.getDecryptRequest(req.app, req.encryptedRequestKey, req.encryptedRequest);
      req.unencryptedRequest = resp.data;
      dispatch(tceppsActions.initializeTceppsAction(req));

      return () => {
        dispatch(tceppsActions.resetTceppsAction());
      };
    };
    const requestParameters = extractRequestParameters(appKey || "");
    processRequest(requestParameters).then(() => {
      // console.log( 'requestParameters = ' + getStringify(requestParameters));
    });
  }, [dispatch, appKey]);

  //* setup microform...
  useEffect(() => {
    const updateCardBrand = (cardName: string, isValid: boolean, isEmpty: boolean) => {
      const cardBrand = getCardType(cardName);
      creditCardMissingRef.current = isEmpty;
      creditCardInvalidRef.current = !isValid && !isEmpty;

      // let hasError = false;
      // let temp = errorState;
      // if (validatedOnce) {
      //   if (isEmpty) {
      //     temp = { ...temp, creditCardMissing: true, creditCardInvalid: false };
      //     hasError = true;
      //   } else if (!isValid) {
      //     temp = { ...temp, creditCardMissing: false, creditCardInvalid: true };
      //     hasError = true;
      //   } else {
      //     temp = { ...temp, creditCardMissing: false, creditCardInvalid: false };
      //     hasError = true;
      //   }
      //   if (hasError) {
      //     setErrorState(temp);
      //   }
      // }

      if (!isEmpty) {
        if (cardBrand === undefined || cardBrand === null || cardBrand === "") {
          dispatch(errorAction("Please enter a visa or a mastercard or amex or discover card number."));
        } else {
          dispatch(errorAction(""));
        }
      }
      dispatch(cardTypeAction({ cardBrand: cardBrand || "" }));
    };

    const initializeMicroform = async (captureContext: any) => {
      dispatch(setCaptureContext(captureContext));
      const flex = (await new (window as any).Flex(captureContext)) as Microform;
      const microform = await flex.microform("card", { styles: flexStyles });
      creditCardMicroNumber = await microform.createField("number", { placeholder: "Card Number" });
      await creditCardMicroNumber.load("#creditCardNumber");
      dispatch(microformInitializedAction(microform));

      if (creditCardMicroNumber) {
        setCreditCardNumber(true);
        creditCardMicroNumber.on("change", (data: any) => {
          if (data.card && data.card.length > 0) {
            updateCardBrand(data.card[0].name, data.valid, data.empty);
          } else {
            updateCardBrand("", data.valid, data.empty);
          }
        });
        creditCardMicroNumber.on("focus", function () {
          (document.querySelector("#creditCardNumber") as HTMLDivElement).style.outline = "5px auto -webkit-focus-ring-color";
          if (isFirefox) {
            (document.querySelector("#creditCardNumber") as HTMLDivElement).style.outline = "1px solid deepskyblue";
            (document.querySelector("#creditCardNumber") as HTMLDivElement).style.outlineOffset = "2px";
            (document.querySelector("#creditCardNumber") as HTMLDivElement).style.border = "1.5px solid blue";
          }
        });
        creditCardMicroNumber.on("blur", function () {
          (document.querySelector("#creditCardNumber") as HTMLDivElement).style.outline = "none";
          (document.querySelector("#creditCardNumber") as HTMLDivElement).style.borderRadius = "2px";
          (document.querySelector("#creditCardNumber") as HTMLDivElement).style.border = "1px solid";
          if (isFirefox) {
            (document.querySelector("#creditCardNumber") as HTMLDivElement).style.outlineOffset = "0px";
            (document.querySelector("#creditCardNumber") as HTMLDivElement).style.border = "1px solid #858585";
          }
        });
        creditCardMicroNumber.on("load", function () {
          dispatch(loadingAction(false));
          creditCardMicroNumber.focus();
        });
        creditCardMicroNumber.focus();
      }
    };

    const getCaptureContext = () => {
      // const iframeUrl = getIframeUrl();
      const iframeUrl = extractDomain(proxyUrl);
      // console.log("iframeUrl:" + iframeUrl);
      PaymentService.getCaptureContext(iframeUrl)
        .then((resp) => {
          // const captureContext = resp.data.data;
          const captureContext = resp.data.captureContext;
          dispatch(setCaptureContext(captureContext));
          const { clientLibrary, clientLibraryIntegrity } = extractClientLibrary(resp.data.json);
          dispatch(contextLoadedAction(captureContext));
          if (!(window as any).Flex) {
            loadCybersourceJS(captureContext, clientLibrary, clientLibraryIntegrity, initializeMicroform);
          } else {
            initializeMicroform(captureContext);
          }
        })
        .catch((err: Error | AxiosError) => {
          if (axios.isAxiosError(err)) {
            dispatch(errorAction("AxiosError: call to initialize microForm failed. " + err.message + ". Please check console."));
          } else {
            dispatch(errorAction("Initialize microForm failed. " + err.message + ". Please check console."));
          }
          LogService.logMessage("S21CSA", LOGERRORLEVEL, "Initialize microForm failed. " + err.message);
        });
    };

    if (!creditCardNumber && proxyUrl && proxyUrl.length > 0) {
      getCaptureContext();
    }
  }, [dispatch, proxyUrl, creditCardNumber, errorState, validatedOnce]);

  const playWrong = () => {
    new Audio(beepSound).play();
  };

  const handleChange = (event: any) => {
    const field = event.target.name as string;
    let correctFormat = true;
    _.set(errorState, field + "Missing", event.target.value.trim().length > 0 ? false : true);

    if (field === "ccExp" && event.target.value.trim().length === 7) {
      let cardYearMonth = event.target.value.trim().substring(3, 8) + event.target.value.trim().substring(0, 2);

      if (!event.target.value.trim().match("^((0[1-9])|(1[0-2]))/([2-9][0-9][0-9][0-9])$")) {
        _.set(errorState, field + "MonthInvalid", true);
      } else if (cardYearMonth < getCurrentYearMonth()) {
        _.set(errorState, field + "Expired", true);
      } else {
        _.set(errorState, field + "MonthInvalid", false);
        _.set(errorState, field + "Expired", false);
      }
    }
    if (field === "ccExp") {
      let dateValue = event.target.value.trim();
      const regex = /^[0-9/]*$/;
      correctFormat = false;
      if (dateValue === "" || regex.test(dateValue)) {
        correctFormat = true;
      } else {
        playWrong();
      }
    } else if (field === "customerZIP") {
      let zipValue = event.target.value.trim();
      correctFormat = false;
      const formattedValue = zipValue.replace(/[^0-9-]/g, "");
      // Limit total length to prevent excessively long inputs
      if (formattedValue.length <= 10 && formattedValue.length === zipValue.length) {
        // 5 digits + 1 hyphen + 4 digits
        correctFormat = true;
      } else {
        playWrong();
      }
    }
    if (correctFormat) {
      const changedState: { [index: string]: string | boolean } = { ...s21CsaState };
      changedState[field] = (event.target.value as string).toUpperCase();
      dispatch(changeAction(changedState));
    }

    setErrorState(errorState);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    const field = (event.target as any).name as string;
    if (field === "profileOverrideFlag" && event.shiftKey && event.key === "Tab") {
      if (creditCardMicroNumber !== undefined && creditCardMicroNumber !== null) {
        creditCardMicroNumber.focus();
      }
    }
  };

  const creditCardStyle = {
    appearance: "auto",
    backgroundColor: "white",
    border: "1px solid #858585",
    borderImage: "initial",
    color: "fieldtext",
    cursor: "text",
    display: "inline-block",
    fontFamily: "'Arial',sans-serif",
    fontSize: "8px",
    height: "13px",
    letterSpacing: "normal",
    lineHeight: "normal",
    margin: "0",
    padding: "0 0 0 2px",
    paddingBlock: "1px",
    paddingInline: "2px",
    textAlign: "start",
    textIndent: "0px",
    textRendering: "auto",
    textShadow: "none",
    textTransform: "none",
    width: "130px", //"163px"
    wordSpacing: "normal",
  } as React.CSSProperties;

  const tooltipStyle = {
    fontSize: "10pt",
    backgroundColor: "#ff6060",
  };
  const tooltipCardStyle = {
    fontSize: "10pt",
    backgroundColor: "#ff6060",
    marginLeft: "20px",
  };
  const tableStyle = {
    fontSize: "8pt",
    margin: "0px",
    padding: "0px",
    fontFamily: "'Arial',sans-serif",
    align: "left",
    display: "flex",
    tableLayout: "fixed",
    borderSpacing: "0px",
    wordWrap: "break-word",
  } as React.CSSProperties;

  const getDateErrorMessage = (): string => {
    let msg = "";
    if (errorState.ccExpMissing) {
      msg = "Please enter credit card expiration date.";
    } else if (errorState.ccExpExpired) {
      msg = "Date is expired. Please enter valid date.";
    } else if (errorState.ccExpMonthInvalid) {
      msg = "Please enter a valid date.";
    }
    return msg;
  };

  return (
    <div className={`${classesCsa.s21csa}`}>
      <form id="tcepps" name="tcepps" action={tceppsState.cpgmuiApiUrl} target="_self">
        <input id="app" name="app" type="hidden" value={tceppsState.app} />
        <input id="token" name="token" type="hidden" value={tceppsState.token} />
        <input id="sign" name="sign" type="hidden" value={tceppsState.sign} />
        <input id="serviceOperation" name="serviceOperation" type="hidden" value="" />
        <input id="encryptedRequest" name="encryptedRequest" type="hidden" value={tceppsState.encryptedRequest} />
        <input id="encryptedRequestKey" name="encryptedRequestKey" type="hidden" value={tceppsState.encryptedRequestKey} />
        <input id="lastFourDigits" name="lastFourDigits" type="hidden" value={paymentInfo.lastFourDigits || ""} />
      </form>

      <form id="ppa" name="ppa">
        <input id="cardBrand" name="cardBrand" type="hidden" value={s21CsaState.cardBrand} />
        <input id="ccAccountNum" name="ccAccountNum" type="hidden" value={"TT=" + (paymentInfo.jti || "")} />
        <input
          id="ccExp"
          name="ccExp"
          type="hidden"
          value={s21CsaState.ccExp ? s21CsaState.ccExp.substring(3, 8) + s21CsaState.ccExp.substring(0, 2) : ""}
        />
        <input id="avsName" name="avsName" type="hidden" value={s21CsaState.customerName} />
        <input id="avsAddress1" name="avsAddress1" type="hidden" value={s21CsaState.customerAddress1} />
        <input id="avsAddress2" name="avsAddress2" type="hidden" value={s21CsaState.customerAddress2} />
        <input id="avsCity" name="avsCity" type="hidden" value={s21CsaState.customerCity} />
        <input id="avsState" name="avsState" type="hidden" value={s21CsaState.customerState} />
        <input id="avsZip" name="avsZip" type="hidden" value={s21CsaState.customerZIP} />
        <input id="avsCountryCode" name="avsCountryCode" type="hidden" value={s21CsaState.customerCountryCode || "US"} />
        <input id="customerName" name="customerName" type="hidden" value={s21CsaState.customerName} />
        <input id="customerAddress1" name="customerAddress1" type="hidden" value={s21CsaState.customerAddress1} />
        <input id="customerAddress2" name="customerAddress2" type="hidden" value={s21CsaState.customerAddress2} />
        <input id="customerCity" name="customerCity" type="hidden" value={s21CsaState.customerCity} />
        <input id="customerState" name="customerState" type="hidden" value={s21CsaState.customerState} />
        <input id="customerZIP" name="customerZIP" type="hidden" value={s21CsaState.customerZIP} />
        <input id="customerCountryCode" name="customerCountryCode" type="hidden" value={s21CsaState.customerCountryCode || "US"} />
        <input id="customerEmail" name="customerEmail" type="hidden" value="null@cybersource.com" />
        <input id="merchantID" name="merchantID" type="hidden" value={s21CsaState.merchantID} />
        <input id="profileOverrideFlag" name="profileOverrideFlag" type="hidden" value={s21CsaState.profileOverrideFlag} />
        <input id="orbitalConnectionUsername" name="orbitalConnectionUsername" type="hidden" value="" />
        <input id="orbitalConnectionPassword" name="orbitalConnectionPassword" type="hidden" value="" />
        <input id="orderDefaultDescription" name="orderDefaultDescription" type="hidden" value="" />
        <input id="orderDefaultAmount" name="orderDefaultAmount" type="hidden" value="" />
        <input id="captureContext" name="captureContext" type="hidden" value={s21CsaState.captureContext} />
        <input id="microformToken" name="microformToken" type="hidden" value={s21CsaState.microformToken} />
      </form>

      <form id="pno" name="pno">
        <input id="cardBrand" name="cardBrand" type="hidden" value={s21CsaState.cardBrand} />
        <input id="ccAccountNum" name="ccAccountNum" type="hidden" value={"TT=" + (paymentInfo.jti || "")} />
        <input
          id="ccExp"
          name="ccExp"
          type="hidden"
          value={s21CsaState.ccExp ? s21CsaState.ccExp.substring(3, 8) + s21CsaState.ccExp.substring(0, 2) : ""}
        />
        <input id="avsName" name="avsName" type="hidden" value={s21CsaState.customerName} />
        <input id="avsAddress1" name="avsAddress1" type="hidden" value={s21CsaState.customerAddress1} />
        <input id="avsAddress2" name="avsAddress2" type="hidden" value={s21CsaState.customerAddress2} />
        <input id="avsCity" name="avsCity" type="hidden" value={s21CsaState.customerCity} />
        <input id="avsState" name="avsState" type="hidden" value={s21CsaState.customerState} />
        <input id="avsZip" name="avsZip" type="hidden" value={s21CsaState.customerZIP} />
        <input id="avsCountryCode" name="avsCountryCode" type="hidden" value={s21CsaState.customerCountryCode || "US"} />
        <input id="customerName" name="customerName" type="hidden" value={s21CsaState.customerName} />
        <input id="customerAddress1" name="customerAddress1" type="hidden" value={s21CsaState.customerAddress1} />
        <input id="customerAddress2" name="customerAddress2" type="hidden" value={s21CsaState.customerAddress2} />
        <input id="customerCity" name="customerCity" type="hidden" value={s21CsaState.customerCity} />
        <input id="customerState" name="customerState" type="hidden" value={s21CsaState.customerState} />
        <input id="customerZIP" name="customerZIP" type="hidden" value={s21CsaState.customerZIP} />
        <input id="customerCountryCode" name="customerCountryCode" type="hidden" value={s21CsaState.customerCountryCode || "US"} />
        <input id="customerEmail" name="customerEmail" type="hidden" value="null@cybersource.com" />
        <input id="merchantID" name="merchantID" type="hidden" value={s21CsaState.merchantID} />
        <input id="orbitalConnectionUsername" name="orbitalConnectionUsername" type="hidden" value="" />
        <input id="orbitalConnectionPassword" name="orbitalConnectionPassword" type="hidden" value="" />
        <input id="switchSoloIssueNum" name="switchSoloIssueNum" type="hidden" value="" />
        <input id="switchSoloCardStartDate" name="switchSoloCardStartDate" type="hidden" value="" />
        <input id="authenticationECIInd" name="authenticationECIInd" type="hidden" value="" />
        <input id="addProfileFromOrder" name="addProfileFromOrder" type="hidden" value="" />
        <input id="profileOrderOverideInd" name="profileOrderOverideInd" type="hidden" value="" />
        <input id="captureContext" name="captureContext" type="hidden" value={s21CsaState.captureContext} />
        <input id="microformToken" name="microformToken" type="hidden" value={s21CsaState.microformToken} />
      </form>

      <div className={`${classesCsa.s21csa} ${classesCsa.s21csaDivTop}`}>
        <form id="creditCard" name="creditCard">
          <table className="inputStyle" style={tableStyle}>
            <tbody>
              <tr>
                <td className={`${classesCsa.s21csa} ${classesCsa.padRight}`}>Credit Card Account Number</td>
                <td>
                  <div
                    id="creditCardNumber"
                    style={creditCardStyle}
                    className={classNames(classesCsa.s21csa, {
                      [classesCsa.fieldError]: validatedOnce && (creditCardMissingRef.current || creditCardInvalidRef.current),
                      [classesCsa.fieldOK]: validatedOnce && !creditCardMissingRef.current && !creditCardInvalidRef.current,
                    })}
                    tabIndex={1}
                    aria-disabled={!s21CsaState.newCreditCardProfileCreation}
                  >
                    <Tooltip
                      anchorSelect="#creditCardNumber"
                      style={tooltipCardStyle}
                      place="right-start"
                      offset={2}
                      variant="error"
                      hidden={!(validatedOnce && creditCardMissingRef.current)}
                      content="Please enter a credit card number."
                    />
                    <Tooltip
                      anchorSelect="#creditCardNumber"
                      style={tooltipCardStyle}
                      place="right-start"
                      offset={2}
                      variant="error"
                      hidden={!(validatedOnce && creditCardInvalidRef.current)}
                      content="Please enter a visa or a mastercard or amex or discover card number."
                    />
                  </div>
                </td>
                <td className={`${classesCsa.s21csa} ${classesCsa.padRight} ${classesCsa.padleft}`}>Card Holder Name</td>
                <td colSpan={3} className="stab">
                  <input
                    className={classNames(classesCsa.s21csa, classesCsa.textInput, {
                      [classesCsa.fieldError]: validatedOnce && errorState.customerNameMissing,
                      [classesCsa.fieldOK]: !(validatedOnce && errorState.customerNameMissing),
                    })}
                    // className={classNames({
                    //   textInput: true,
                    //   fieldError: validatedOnce && errorState.customerNameMissing,
                    //   fieldOK: !(validatedOnce && errorState.customerNameMissing),
                    // })}
                    tabIndex={4}
                    id="customerName"
                    name="customerName"
                    ref={customerNameRef}
                    type="text"
                    size={30}
                    maxLength={30}
                    onBlur={ezfToUpperOnBlur}
                    onKeyDown={ezfToUpperOnKeyDown}
                    value={s21CsaState.customerName}
                    disabled={!s21CsaState.newCreditCardProfileCreation}
                    onChange={handleChange}
                  />
                  <Tooltip
                    anchorSelect="#customerName"
                    style={tooltipStyle}
                    place="bottom"
                    offset={2}
                    variant="error"
                    hidden={!(validatedOnce && errorState.customerNameMissing)}
                    content="Please enter card holder name."
                  />
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="stab" align="left">
                  &nbsp;&nbsp;&nbsp;&nbsp; <span> </span>
                  <input
                    className={`${classesCsa.s21csa} ${classesCsa.textInput}`}
                    tabIndex={2}
                    type="checkbox"
                    id="profileOverrideFlag"
                    name="profileOverrideFlag"
                    ref={profileOverrideFlagRef}
                    value={s21CsaState.profileOverrideFlag}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    disabled={!s21CsaState.newCreditCardProfileCreation}
                  />
                  <span> is this a single charge P-Card?</span>
                </td>
                <td className={`${classesCsa.s21csa} ${classesCsa.padRight} ${classesCsa.padleft}`}>Addressline 1</td>
                <td colSpan={3}>
                  <input
                    className={classNames(classesCsa.s21csa, classesCsa.textInput, {
                      [classesCsa.fieldError]: validatedOnce && errorState.customerAddress1Missing,
                      [classesCsa.fieldOK]: !(validatedOnce && errorState.customerAddress1Missing),
                    })}
                    //  className={classNames({
                    //   textInput: true,
                    //   fieldError: validatedOnce && errorState.customerAddress1Missing,
                    //   fieldOK: !(validatedOnce && errorState.customerAddress1Missing),
                    // })}
                    tabIndex={5}
                    id="customerAddress1"
                    name="customerAddress1"
                    ref={customerAddress1Ref}
                    type="text"
                    size={30}
                    maxLength={30}
                    onBlur={ezfToUpperOnBlur}
                    onKeyDown={ezfToUpperOnKeyDown}
                    value={s21CsaState.customerAddress1}
                    disabled={!s21CsaState.newCreditCardProfileCreation}
                    onChange={handleChange}
                  />
                  <Tooltip
                    anchorSelect="#customerAddress1"
                    style={tooltipStyle}
                    place="bottom"
                    offset={2}
                    variant="error"
                    hidden={!(validatedOnce && errorState.customerAddress1Missing)}
                    content="Please enter a customer address."
                  />
                </td>
              </tr>
              <tr>
                <td className={`${classesCsa.s21csa} ${classesCsa.padRight}`}>Credit Card Type</td>
                <td>
                  <select
                    className={`${classesCsa.s21csa} ${classesCsa.textInput}`}
                    tabIndex={-1}
                    id="cardBrand"
                    name="cardBrand"
                    disabled={true}
                    value={s21CsaState.cardBrand}
                    onChange={handleChange}
                  >
                    <option value=""> </option>
                    <option value="AX"> AMEX</option>
                    <option value="DI">DISCOVER</option>
                    <option value="DS">DISCOVER</option>
                    <option value="MC">MASTER</option>
                    <option value="VI">VISA</option>
                  </select>
                </td>
                <td className={`${classesCsa.s21csa} ${classesCsa.padRight} ${classesCsa.padleft}`}>Addressline 2</td>
                <td colSpan={3}>
                  <input
                    className={`${classesCsa.s21csa} ${classesCsa.textInput}`}
                    tabIndex={6}
                    id="customerAddress2"
                    name="customerAddress2"
                    type="text"
                    size={30}
                    maxLength={30}
                    onBlur={ezfToUpperOnBlur}
                    onKeyDown={ezfToUpperOnKeyDown}
                    value={s21CsaState.customerAddress2}
                    disabled={!s21CsaState.newCreditCardProfileCreation}
                    onChange={handleChange}
                  />
                </td>
              </tr>
              <tr>
                <td className={`${classesCsa.s21csa} ${classesCsa.padRight}`}>Card Expiration Date</td>
                <td className="stab">
                  <input
                    className={classNames(classesCsa.s21csa, classesCsa.textInput, {
                      [classesCsa.fieldError]:
                        validatedOnce && (errorState.ccExpMonthInvalid || errorState.ccExpExpired || errorState.ccExpMissing),
                      [classesCsa.fieldOK]: !(
                        validatedOnce &&
                        (errorState.ccExpMonthInvalid || errorState.ccExpExpired || errorState.ccExpMissing)
                      ),
                    })}
                    // className={classNames({
                    //   textInput: true,
                    //   fieldError: validatedOnce && (errorState.ccExpMonthInvalid || errorState.ccExpExpired || errorState.ccExpMissing),
                    //   fieldOK: !(validatedOnce && (errorState.ccExpMonthInvalid || errorState.ccExpExpired || errorState.ccExpMissing)),
                    // })}
                    tabIndex={3}
                    id="ccExp"
                    name="ccExp"
                    ref={ccExpRef}
                    type="text"
                    size={7}
                    maxLength={7}
                    placeholder="MM/YYYY"
                    onBlur={ezfToUpperOnBlur}
                    value={s21CsaState.ccExp}
                    disabled={!s21CsaState.newCreditCardProfileCreation}
                    onChange={handleChange}
                    onKeyUp={keyUpDateEvent}
                  />
                  &nbsp;&nbsp; (MM/YYYY)
                  <Tooltip
                    anchorSelect="#ccExp"
                    style={tooltipStyle}
                    place="bottom"
                    offset={2}
                    variant="error"
                    hidden={!(validatedOnce && (errorState.ccExpMonthInvalid || errorState.ccExpExpired || errorState.ccExpMissing))}
                    content={getDateErrorMessage()}
                  />
                </td>
                <td className={`${classesCsa.s21csa} ${classesCsa.padRight} ${classesCsa.padleft}`}>City</td>
                <td>
                  <input
                    className={classNames(classesCsa.s21csa, classesCsa.textInput, {
                      [classesCsa.fieldError]: validatedOnce && errorState.customerCityMissing,
                      [classesCsa.fieldOK]: !(validatedOnce && errorState.customerCityMissing),
                    })}
                    // className={classNames({
                    //   textInput: true,
                    //   fieldError: validatedOnce && errorState.customerCityMissing,
                    //   fieldOK: !(validatedOnce && errorState.customerCityMissing),
                    // })}
                    tabIndex={7}
                    id="customerCity"
                    name="customerCity"
                    ref={customerCityRef}
                    type="text"
                    size={20}
                    maxLength={20}
                    onBlur={ezfToUpperOnBlur}
                    onKeyDown={ezfToUpperOnKeyDown}
                    value={s21CsaState.customerCity}
                    disabled={!s21CsaState.newCreditCardProfileCreation}
                    onChange={handleChange}
                  />
                  <Tooltip
                    anchorSelect="#customerCity"
                    style={tooltipStyle}
                    place="bottom"
                    offset={2}
                    variant="error"
                    hidden={!(validatedOnce && errorState.customerCityMissing)}
                    content="Please enter a city."
                  />
                </td>
                <td className={`${classesCsa.s21csa} ${classesCsa.padRight} ${classesCsa.padleft}`}>State</td>
                <td>
                  <input
                    className={classNames(classesCsa.s21csa, classesCsa.textInput, {
                      [classesCsa.fieldError]: validatedOnce && errorState.customerStateMissing,
                      [classesCsa.fieldOK]: !(validatedOnce && errorState.customerStateMissing),
                    })}
                    // className={classNames({
                    //   textInput: true,
                    //   fieldError: validatedOnce && errorState.customerStateMissing,
                    //   fieldOK: !(validatedOnce && errorState.customerStateMissing),
                    // })}
                    tabIndex={8}
                    id="customerState"
                    name="customerState"
                    ref={customerStateRef}
                    type="text"
                    size={2}
                    maxLength={2}
                    onBlur={ezfToUpperOnBlur}
                    onKeyDown={ezfToUpperOnKeyDown}
                    onChange={handleChange}
                    value={s21CsaState.customerState}
                    disabled={!s21CsaState.newCreditCardProfileCreation}
                  />
                  <Tooltip
                    anchorSelect="#customerState"
                    style={tooltipStyle}
                    place="bottom"
                    offset={2}
                    variant="error"
                    hidden={!(validatedOnce && errorState.customerStateMissing)}
                    content="Please enter a state."
                  />
                </td>
              </tr>
              <tr>
                <td> </td>
                <td> </td>
                <td className={`${classesCsa.s21csa} ${classesCsa.padRight} ${classesCsa.padleft}`}>Post Code</td>
                <td>
                  <input
                    className={classNames(classesCsa.s21csa, classesCsa.textInput, {
                      [classesCsa.fieldError]: validatedOnce && errorState.customerZIPMissing,
                      [classesCsa.fieldOK]: !(validatedOnce && errorState.customerZIPMissing),
                    })}
                    //  className={classNames({
                    //     textInput: true,
                    //     fieldError: validatedOnce && errorState.customerZIPMissing,
                    //     fieldOK: !(validatedOnce && errorState.customerZIPMissing),
                    //   })}
                    tabIndex={9}
                    id="customerZIP"
                    name="customerZIP"
                    type="text"
                    size={10}
                    maxLength={10}
                    ref={postCodeRef}
                    inputMode="numeric" // Prompts a numeric keyboard on mobile devices
                    placeholder="5 or 9 DIGITS"
                    onBlur={ezfToUpperOnBlur}
                    onKeyDown={ezfToUpperOnKeyDown}
                    onChange={handleChange}
                    value={s21CsaState.customerZIP}
                    disabled={!s21CsaState.newCreditCardProfileCreation}
                  />
                  <Tooltip
                    anchorSelect="#customerZIP"
                    style={tooltipStyle}
                    place="bottom"
                    offset={2}
                    variant="error"
                    hidden={!(validatedOnce && errorState.customerZIPMissing)}
                    content="Please enter a zip code."
                  />
                </td>
                <td className={`${classesCsa.s21csa} ${classesCsa.padRight} ${classesCsa.padleft}`}>Country</td>
                <td>
                  <input
                    className={classNames(classesCsa.s21csa, classesCsa.textInput, {
                      [classesCsa.fieldError]: validatedOnce && errorState.customerCountryCodeMissing,
                      [classesCsa.fieldOK]: !(validatedOnce && errorState.customerCountryCodeMissing),
                    })}
                    // className={classNames({
                    //   textInput: true,
                    //   fieldError: validatedOnce && errorState.customerCountryCodeMissing,
                    //   fieldOK: !(validatedOnce && errorState.customerCountryCodeMissing),
                    // })}
                    tabIndex={10}
                    id="customerCountryCode"
                    name="customerCountryCode"
                    ref={customerCountryCodeRef}
                    type="text"
                    size={2}
                    maxLength={2}
                    onBlur={ezfToUpperOnBlur}
                    onKeyDown={ezfToUpperOnKeyDown}
                    onChange={handleChange}
                    value={s21CsaState.customerCountryCode}
                    disabled={!s21CsaState.newCreditCardProfileCreation}
                  />
                  <Tooltip
                    anchorSelect="#customerCountryCode"
                    style={tooltipStyle}
                    place="bottom"
                    offset={2}
                    variant="error"
                    hidden={!(validatedOnce && errorState.customerCountryCodeMissing)}
                    content="Please enter a country code."
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div style={{ display: "flex", textAlign: "left", verticalAlign: "middle" }}>
            <h1
              className={`${classesCsa.s21csa} ${classesCsa.h1}`}
              id="validationMessages"
              tabIndex={-1}
              style={{
                color: "#D8000C",
                display: "inline-flex" /* keep the background color wrapped tight */,
                backgroundColor: componentObjRef.current.isBackgroundRed ? "#FFBABA" : "white",
              }}
            >
              {validationMessages}
            </h1>
          </div>
        </form>
      </div>
    </div>
  );
}
